import {
    Input,
    MenuItem,
    Select,
    TextField,
    FormControl,
    InputLabel
  } from '@material-ui/core';
import { useAggregatedServices } from '../../utils/aggregateServices';
import {useTranslation} from "react-i18next";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    activitySelect: {
      width: '100%',
      marginBottom: theme.spacing(3),
    },
}))

  const MultiSelect = ({options, input:{value,onChange}, allowMultipleSelection=false})=>{
    const {t} = useTranslation()
    const classes = useStyles();
    const aggregatedActivities = useAggregatedServices(value||[])
    console.log({value});
    
    return (
      <FormControl variant="outlined" className={classes.activitySelect}>
        <InputLabel id="select-label">{t('select_activity')}</InputLabel>
        <Select
        multiple={allowMultipleSelection}
          labelId="select-label"
          id="select"
          label={t('select_activity')}
          color='primary'
          value={value||[]}
          onChange={e=>{
            const newValue=e.target.value
            onChange(Array.isArray(newValue)?newValue:[newValue])}  }
          renderValue={()=>`${aggregatedActivities?.subProfessionId?.heName} - ${aggregatedActivities.duration} ${t('min')} - $${aggregatedActivities.price}`}
        >
          {options?.map((activity) => (
            <MenuItem key={activity._id} value={activity}>
              {`${activity.heName} - ${activity.duration} ${t('min')} - $${activity.price}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
}

export default MultiSelect;